import { render, staticRenderFns } from "./SeminarRowData.vue?vue&type=template&id=b1b66c1e&scoped=true&"
import script from "./SeminarRowData.vue?vue&type=script&lang=js&"
export * from "./SeminarRowData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1b66c1e",
  null
  
)

export default component.exports